/** List style (using by some list APIs for tree-like entities) */
export enum ListStyleEnum {
  /** Show hierarchy */
  HIERARCHY = 'hierarchy',
  /** Show flat list */
  FLAT = 'flat',
}
